export enum USERSUBSCRIPTION {
  PLATINUM,
  GOLD,
  SILVER,
  BRONZE,
}
